import type { ReportRequest } from "../report/contracts";
import type { SessionReport } from "../../features/report/session";
import { guardVietnameseDisplayText } from "./text-guard";
import type { VietnameseReportHeader } from "./types";

const genderVi: Readonly<Record<ReportRequest["calculationGender"], string>> =
  Object.freeze({ nam: "Nam", nu: "Nữ" });

const calendarVi: Readonly<Record<ReportRequest["calendar"], string>> =
  Object.freeze({ solar: "dương lịch", lunar: "âm lịch" });

const timeConfidenceVi: Readonly<
  Record<ReportRequest["birthTimeConfidence"], string>
> = Object.freeze({
  exact: "chính xác",
  approximate: "gần đúng",
  unknown: "chưa rõ",
});

function formatBirthDateVi(request: ReportRequest): string {
  const [year, month, day] = request.birthDate.split("-");
  return `${day}/${month}/${year} (${calendarVi[request.calendar]})`;
}

function formatBirthTimeVi(request: ReportRequest): string {
  return `${request.birthTime} (${timeConfidenceVi[request.birthTimeConfidence]})`;
}

function formatCreatedAtVi(createdAt: string): string {
  try {
    return new Intl.DateTimeFormat("vi-VN", {
      timeZone: "Asia/Ho_Chi_Minh",
      dateStyle: "short",
      timeStyle: "short",
    }).format(new Date(createdAt));
  } catch {
    return createdAt;
  }
}

export function buildReportHeader(
  report: SessionReport,
): VietnameseReportHeader {
  const request = report.request;
  const fullName = guardVietnameseDisplayText(
    request.fullName,
    "Chưa xác định",
  ).textVi;
  const question = guardVietnameseDisplayText(
    request.question,
    "Chưa xác định",
  ).textVi;
  const birthPlace = guardVietnameseDisplayText(
    request.birthPlace.locality,
    "Chưa xác định",
  ).textVi;

  return Object.freeze({
    reportId: report.id,
    version: report.version,
    createdAtVi: formatCreatedAtVi(report.createdAt),
    fullNameVi: fullName,
    genderVi: genderVi[request.calculationGender],
    birthDateVi: formatBirthDateVi(request),
    birthTimeVi: formatBirthTimeVi(request),
    birthPlaceVi: birthPlace,
    questionVi: question,
  });
}
